// http://localhost:3000/banners/pwa?banner_id=c80d6194-6c60-4788-bcd2-525d96bf8eff&px_id=EXAMPLE_PIXEL_ID&ad_type=3

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        // Unregister any stale service workers not pointing to /sw.js (e.g. from old @nuxtjs/pwa)
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (const registration of registrations) {
                const scriptURL = registration.active?.scriptURL || registration.installing?.scriptURL || ''
                if (!scriptURL.endsWith('/sw.js')) {
                    registration.unregister()
                }
            }
        })

        // Parse query params
        const params = new URLSearchParams(window.location.search)
        const hasBannerId = params.has('banner_id')
        const hasPxId = params.has('px_id')
        const hasAdType = params.has('ad_type')

        // Only register SW if all three keys exist
        if (hasBannerId && hasPxId && hasAdType) {
            navigator.serviceWorker
                .register('/sw.js')
                .then(() => {})
                .catch(() => {})

            // beforeinstallprompt
            window.addEventListener('beforeinstallprompt', (event) => {
                event.preventDefault()
                window.homeScreenDeferredPrompt = event
                window.localStorage.removeItem('pwaInstalled')
                window.dispatchEvent(new CustomEvent('a2hsBeforeinstallprompt'))
            })
        }
        // else {
        //   console.log('Required query parameters missing. SW not registered.')
        // }
    })
}
